import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartTitle
} from '@progress/kendo-react-charts';

import BobLoadingMask from '../../../components/BobLoadingMask';

const AvoidedCostsGraph = ({
    bobLoading,
    data,
    hasInitialized,
    ...props
}) => {

    const [scoreChartHeight, setScoreChartHeight] = useState('80vh');
    const minWidth2560 = matchMedia('(min-width: 2560px');
    const zoom125 = matchMedia('(min-resolution: 1.25dppx');
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        const actual = {name: 'Actual', data: []};
        const predicted = {name: 'Expected', data: []};

        data.forEach((item, index) => {
            actual.data.push({ timestamp: new Date(item.day), value: item.dailyActualEnergyUse });

            if (index > 29) {
                predicted.data.push({ timestamp: new Date(item.day), value: item.dailyPredictedEnergyUse });
            }
        });

        setChartData([actual, predicted]);
    }, [data]);

    const updateScoreChart2560 = (e) => {
        if (e.matches) {
            setScoreChartHeight('70vh');
        }
        else {
            setScoreChartHeight('80vh');
        }
    };

    const mqlZoom125 = (e) => {
        if (e.matches) {
            setScoreChartHeight('49vh');
        }
        else {
            setScoreChartHeight('60vh');
        }
    };

    useEffect(() => {
        return () => {
            minWidth2560.removeEventListener('change', updateScoreChart2560);
            zoom125.removeEventListener('change', mqlZoom125);
        };
    }, []);

    useEffect(() => {
        if (window.devicePixelRatio === 1) {
            setScoreChartHeight('60vh');
        }
        else {
            setScoreChartHeight('49vh');
        }

        minWidth2560.addEventListener('change', updateScoreChart2560);
        zoom125.addEventListener('change', mqlZoom125);

        const mediaQuery = window.matchMedia('(min-width: 2560px)');
        if (mediaQuery.matches) {
            updateScoreChart2560(mediaQuery);
        }

    }, []);

    const categoryPlotBands = [
        {
            from:    0,
            to:      30.5,
            color:   '#000',
            opacity: 0.05,
            label:   {
                text:   'Baseline Period',
                font:   '18px sans-serif',
                color:  '#444',
                margin: 10,
                align:  'center'
            },
        },
    ];

    return (
        <div>
            <div>
                <Chart
                    style={{
                        height: scoreChartHeight
                    }}
                    pannable={{ lock: 'y' }}
                    zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                >
                    <ChartTitle text={'Avoided Costs'} align="left" font="12pt sans-serif" />
                    <ChartTooltip
                        shared={true} visible={true} //render={sharedTooltipRender}
                        background="#FFFFFF"
                        opacity={.95}
                    />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            baseUnit="auto"
                            maxDivisions={12}
                            labels={{ visible: true }}
                            plotBands={categoryPlotBands}
                        />
                    </ChartCategoryAxis>
                    <ChartLegend position="top" orientation="horizontal" visible={true} />
                    <ChartSeries>
                        {chartData.map((item, index) => (
                            <ChartSeriesItem
                                dashType={index === 1 ? 'dash' : null}
                                type="line"
                                markers={{ visible: false }}
                                categoryField="timestamp"
                                name={item.name}
                                key={index}
                                data={item.data}
                                field="value"
                                // eslint-disable-next-line react/style-prop-object
                                style="smooth"
                            />
                        ))}
                    </ChartSeries>
                </Chart>
                {
                    bobLoading.includes('FetchEquipmentAvoidedCosts') || bobLoading.includes('FetchSiteAvoidedCosts') || !hasInitialized ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading: state.bob.bobLoading,
    };
};

export default connect(mapStateToProps, null)(AvoidedCostsGraph);
